module.exports = __webpack_public_path__ + "static/media/white-background.837978f7.png";